var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { createSlice } from '@reduxjs/toolkit';
import { v4 } from 'uuid';
import { EventSurface } from '../../types/events';
export var initialState = {
    currentSource: EventSurface.MODAL_INITIALIZATION,
    lastSource: EventSurface.MODAL_INITIALIZATION,
    postLoginAttemptId: null,
    searchSessionId: null,
    loginAttemptId: null,
    manualInstructionsAttemptId: null,
    viewedHomerIFrame: false,
};
export var segmentSlice = createSlice({
    name: 'segment',
    initialState: initialState,
    reducers: {
        updateEventSource: function (state, action) { return (__assign(__assign({}, state), { currentSource: action.payload, lastSource: state.currentSource })); },
        generatePostLoginAttemptId: function (state) { return (__assign(__assign({}, state), { postLoginAttemptId: v4() })); },
        generateSearchSessionId: function (state) { return (__assign(__assign({}, state), { searchSessionId: v4() })); },
        generateManualInstructionsAttemptId: function (state) { return (__assign(__assign({}, state), { manualInstructionsAttemptId: v4() })); },
        setViewedHomerIFrame: function (state) { return (__assign(__assign({}, state), { viewedHomerIFrame: true })); },
    },
});
export var updateEventSource = (_a = segmentSlice.actions, _a.updateEventSource), generatePostLoginAttemptId = _a.generatePostLoginAttemptId, generateSearchSessionId = _a.generateSearchSessionId, generateManualInstructionsAttemptId = _a.generateManualInstructionsAttemptId, setViewedHomerIFrame = _a.setViewedHomerIFrame;
export var selectCurrentSource = function (state) {
    return state.segment.currentSource;
};
export var selectViewedHomerIFrame = function (state) {
    return state.segment.viewedHomerIFrame;
};
export var selectManualInstructionsAttemptId = function (state) {
    return state.segment.manualInstructionsAttemptId;
};
export var selectPostLoginAttemptId = function (state) {
    return state.segment.postLoginAttemptId;
};
export var selectSearchSessionId = function (state) {
    return state.segment.searchSessionId;
};
export var selectLastSource = function (state) { return state.segment.lastSource; };
export default segmentSlice.reducer;
